import React from 'react';

const helptenLogo = require('./Helpten_logo_icon_white_lores.png')

export default () => {
  return(
    <div className="login-page center-block form-signin">
      <div className="login-content">
        <img src={helptenLogo} height="50px"
             style={{marginTop: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto'}}
             alt="Helpten logo"
        />
      </div>
    </div>
  )
}
